import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import PhoneInput from 'react-phone-input-2';
import { getAuthConnection, resetConnection, loading } from 'auth-connections/auth-connection-actions';
import { authConnection } from 'auth-connections/auth-connection-selectors';
import 'react-phone-input-2/lib/style.css';
import { GoDot, GoDotFill } from "react-icons/go";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { TfiControlBackward } from "react-icons/tfi";
import './Register.scss';
import { bindActionCreators } from 'redux';
import { signIn, onboardOrg, onBoard, checkEmailExists } from '../../identity/action-creators';
import Header from '../../components/header/Header';
import Footer from 'components/footer/Footer';
import local from 'services/localization/local';
import AgreementSteps from 'shared/AgreementSteps/AgreementSteps';
import { LoadingIcon } from 'shared';
import * as validators from 'services/fields/field-validators';



class PdlRegister extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                firstName: '',
                lastName: '',
                phoneNumber: '',
                email: '',
                password: '',
                companyName: '',
                website: '',
                providerNPI: '',
                providerAddress: '',
                zipCode: '',
                city: '',
                state: '',
                country: ''
            },
            errors: {
                firstName: '',
                lastName: '',
                email: '',
                password: ''
            },
            passwordRules: {
                minLength: false,
                uppercase: false,
                specialChar: false,
                alphanumeric: false
            },
            formStep: 1,
            isPasswordFocused: false,
            showPasswordError: false,
            showPassword: false,
            mobileCountry: 'us',
            loadingContinue: false,
            loadingSubmit: false,
            emailError: '',
            orgNameMessage: "",
            phoneError: "",
            addressError: "",
            zipError: "",
            cityError: "",
            stateError: "",
            npiError: ""
        };
    }

    componentDidMount() {
        const savedStep1Data = localStorage.getItem('formStep1Data');

        if (savedStep1Data) {
            const parsedData = JSON.parse(savedStep1Data);
            this.setState((prevState) => ({
                formStep: 2,
                formData: {
                    ...prevState.formData,
                    ...parsedData
                },
                passwordRules: {
                    minLength: parsedData.password.length >= 8,
                    uppercase: /[A-Z]/.test(parsedData.password),
                    specialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(parsedData.password),
                    alphanumeric: /[A-Za-z]/.test(parsedData.password) && /\d/.test(parsedData.password)
                }
            }));
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        const { formData, mobileCountry } = this.state;

        if (name === 'password') {
            const cleanValue = value.replace(/\s/g, '');
            const rules = {
                minLength: cleanValue.length >= 8,
                uppercase: /[A-Z]/.test(cleanValue),
                specialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(cleanValue),
                alphanumeric: /[A-Za-z]/.test(cleanValue) && /\d/.test(cleanValue)
            };
            this.setState({
                formData: { ...formData, password: cleanValue },
                passwordRules: rules
            });
        } else if (name === 'zipCode') {
            const numericValue = value.replace(/\D/g, '').slice(0, 5);

            this.setState({
                formData: { ...formData, zipCode: numericValue }
            }, () => {
                if (mobileCountry === 'us' && numericValue.length === 5) {
                    this.fetchCityStateFromZip(numericValue);
                } else {
                    this.setState({
                        formData: {
                            ...this.state.formData,
                            city: '',
                            state: '',
                            country: ''
                        }
                    });
                }
            });
        } else if (name === 'providerNPI') {
            const numericValue = value.replace(/\D/g, '').slice(0, 10);

            this.setState({
                formData: { ...formData, providerNPI: numericValue }
            });
        } else {
            this.setState({
                formData: { ...formData, [name]: value }
            });
        }
    };

    fetchCityStateFromZip = async (zip) => {
        try {
            const res = await fetch(`https://api.zippopotam.us/us/${zip}`);
            if (!res.ok) throw new Error('Invalid ZIP');
            const data = await res.json();
            const place = data.places?.[0];
            if (place) {
                this.setState({
                    formData: {
                        ...this.state.formData,
                        city: place['place name'],
                        state: place['state abbreviation'],
                        country: data.country
                    }
                });
            }
        } catch (err) {
            this.setState({
                formData: {
                    ...this.state.formData,
                    city: '',
                    state: '',
                    country: ''
                }
            });
        }
    };

    handlePhoneChange = (value, data) => {
        this.setState({
            formData: { ...this.state.formData, phoneNumber: value },
            mobileCountry: data.countryCode
        });
    };

    handleContinue = async () => {
        const { firstName, lastName, email, password } = this.state.formData;
        const { minLength, uppercase, specialChar, alphanumeric } = this.state.passwordRules;
        let errors = {};

        if (!firstName.trim()) {
            errors.firstName = "First name is required";
        }

        if (!lastName.trim()) {
            errors.lastName = "Last name is required";
        }
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email.trim()) {
            errors.email = "Email is required";
        } else if (!emailPattern.test(email)) {
            errors.email = "Enter a valid email address";
        }

        if (!password.trim()) {
            errors.password = "Password is required";
        } else if (!(minLength && uppercase && specialChar && alphanumeric)) {
            errors.password = "Password must meet the conditions above.";
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ errors, showPasswordError: false });
            return;
        }

        this.setState({ loadingContinue: true, errors: {} });

        try {
            const step1Data = { firstName, lastName, email, password };
            const response = await this.props.actions.onboardOrg(step1Data);
            if (response?.email) {
                localStorage.setItem('email', JSON.stringify(response.email));
            }
            localStorage.setItem('formStep1Data', JSON.stringify(step1Data));
            this.setState({ formStep: 2, showPasswordError: false, loadingContinue: false });
        } catch (error) {
            console.error('onBoard API error:', error);
            this.setState({
                emailError: error.message || 'Failed to register contact details. Please try again.',
                loadingContinue: false
            });
        }

    };



    handlePrevious = () => {
        this.setState({ formStep: 1, showPasswordError: false });
    };

    handleSubmitForm = async () => {
        const { formData } = this.state;

        let errors = {};

        if (!formData.companyName?.trim()) {
            errors.companyName = "Organization Name is Required";
        }

        // if (!formData.phoneNumber?.trim()) {
        //     errors.phoneNumber = "Phone Number is Required";
        // }

        // if (!formData.providerAddress?.trim()) {
        //     errors.providerAddress = "Address is Required";
        // }

        // if (!formData.zipCode?.trim()) {
        //     errors.zipCode = "Zip Code is Required";
        // }

        // if (!formData.city?.trim()) {
        //     errors.city = "City is Required";
        // }

        // if (!formData.state?.trim()) {
        //     errors.state = "State is Required";
        // }

        const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/i;
        if (formData.website && !urlPattern.test(formData.website.trim())) {
            errors.website = "Please enter a valid URL";
        }
        if (formData.providerNPI && !/^\d{10}$/.test(formData.providerNPI.trim())) {
            errors.providerNPI = "NPI must be exactly 10 digits";
        }

        if (Object.keys(errors).length > 0) {
            this.setState({
                orgNameMessage: errors.companyName || "",
                // phoneError: errors.phoneNumber || "",
                // addressError: errors.providerAddress || "",
                // zipError: errors.zipCode || "",
                // cityError: errors.city || "",
                // stateError: errors.state || "",
                websiteError: errors.website || "",
                npiError: errors.providerNPI || "",
            });
            return;
        }

        this.setState({
            orgNameMessage: "",
            // phoneError: "",
            // addressError: "",
            // zipError: "",
            // cityError: "",
            // stateError: "",
            // websiteError: ""
        });

        try {
            const response = await this.props.actions.onboardOrg(formData);

            if (response?.id) {
                localStorage.setItem('registeredUserId', response.id);
            }

            this.setState({ formStep: 3, loadingSubmit: false });
        } catch (error) {
            console.error('onboardOrg API error:', error);
        }
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { formData, passwordRules } = this.state;
        const { minLength, uppercase, specialChar, alphanumeric } = passwordRules;

        if (!minLength || !uppercase || !specialChar || !alphanumeric) {
            this.setState({ showPasswordError: true });
            return;
        }
        this.setState({ loadingSubmit: true });
        try {
            localStorage.setItem('formStep2Data', JSON.stringify(formData));
        } catch (error) {
            console.error('onboardOrg API error:', error);
            this.setState({ loadingSubmit: false });
        }
    };


    handleAgreementComplete = () => {
        window.location.href = '/plan-details';
    };

    handleSignIn = () => {
        window.location.href = '/'
    }




    render() {
        const { formData, passwordRules, formStep, showPassword, showPasswordError, isPasswordFocused, mobileCountry, loadingContinue, loadingSubmit } = this.state;
        const allRulesPassed = Object.values(passwordRules).every(Boolean)

        return (
            <div className="register-wrapper">
                <div className='register-header'>
                    <Header isSignIn></Header>
                </div>
                <div className='register-container'>

                    <div className="form-side">
                        <form className="register-form" onSubmit={this.handleSubmit}>
                            {formStep === 1 && (
                                <div className='contact-container'>
                                    <div className='contact-heading'>
                                        <h4>Go Live !</h4>
                                    </div>
                                    <div className="register-form-container-1">
                                        <h3 className='form-head-text'>Contact details</h3>
                                        {/* {this.state.emailError && (
                                            <div className="error-message">
                                                {this.state.emailError}
                                            </div>
                                        )} */}
                                        <div className="form-group">
                                            <div className="form-field">
                                                <label>First Name <span>*</span></label>
                                                <input type="text" name="firstName" placeholder='Enter First name' value={formData.firstName} onChange={this.handleChange} required />
                                                {this.state.errors.firstName && (
                                                    <span className="error-text">{this.state.errors.firstName}</span>
                                                )}
                                            </div>
                                            <div className="form-field">
                                                <label>Last Name <span>*</span></label>
                                                <input type="text" name="lastName" placeholder='Enter Last name' value={formData.lastName} onChange={this.handleChange} required />
                                                {this.state.errors.lastName && (
                                                    <span className="error-text">{this.state.errors.lastName}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-field full">
                                                <label>Email <span>*</span></label>
                                                <input type="email" name="email" placeholder='Enter your e-mail' value={formData.email} onChange={this.handleChange} validate={[validators.email]} />
                                                {this.state.errors.email && (
                                                    <span className="error-text">{this.state.errors.email}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-field">
                                                <label>Password <span>*</span></label>
                                                <div className="password-input-wrapper">
                                                    <input
                                                        placeholder='Create Password'
                                                        type={showPassword ? 'text' : 'password'}
                                                        name="password"
                                                        value={formData.password}
                                                        onChange={this.handleChange}
                                                        onFocus={() => this.setState({ isPasswordFocused: true, showPasswordError: false })}
                                                        onBlur={() => {
                                                            const { minLength, uppercase, specialChar, alphanumeric } = passwordRules;
                                                            const allRulesPass = minLength && uppercase && specialChar && alphanumeric;
                                                            this.setState({
                                                                isPasswordFocused: false,
                                                                showPasswordError: !allRulesPass
                                                            });
                                                        }}
                                                        required
                                                    />
                                                    <span className="toggle-eye" onClick={() => this.setState({ showPassword: !showPassword })}>
                                                        {showPassword ? <IoEyeOutline /> : <IoEyeOffOutline />}
                                                    </span>
                                                </div>
                                                {isPasswordFocused && (
                                                    <ul className="password-rules">
                                                        <li style={{ color: passwordRules.minLength ? 'green' : 'red' }}>{passwordRules.minLength ? <GoDotFill /> : <GoDot />} Minimum 8 characters</li>
                                                        <li style={{ color: passwordRules.uppercase ? 'green' : 'red' }}>{passwordRules.uppercase ? <GoDotFill /> : <GoDot />} At least one uppercase letter</li>
                                                        <li style={{ color: passwordRules.specialChar ? 'green' : 'red' }}>{passwordRules.specialChar ? <GoDotFill /> : <GoDot />} At least one special character</li>
                                                        <li style={{ color: passwordRules.alphanumeric ? 'green' : 'red' }}>{passwordRules.alphanumeric ? <GoDotFill /> : <GoDot />} Contains letters and numbers</li>
                                                    </ul>
                                                )}
                                                {this.state.errors.password && (
                                                    <span className="error-text">{this.state.errors.password}</span>
                                                )}
                                            </div>
                                        </div>
                                        {/* <div className='continue-button'>
                                        <button
                                            type="button"
                                            className="continue-btn"
                                            onClick={this.handleContinue}
                                        >
                                            {loadingContinue ? <LoadingIcon /> : 'Continue'}
                                        </button>
                                        <p className='login-quote'>Already have an account? <span onClick={this.handleSignIn}>SignIn</span></p>
                                    </div> */}
                                        <button
                                            type="btn"
                                            className="continue-btn"
                                            onClick={this.handleContinue}
                                            disabled={loadingContinue}
                                        >
                                            {loadingContinue ? (
                                                <>
                                                    <LoadingIcon />
                                                </>
                                            ) : (
                                                'Continue'
                                            )}
                                        </button>
                                        <p className='login-quote'>Already have an account? <span onClick={this.handleSignIn}>SignIn</span></p>
                                    </div>
                                </div>
                            )}
                            {formStep === 2 && (
                                <div className='organization-container'>
                                    <div className='contact-heading'>
                                        <h4>Go Live !</h4>
                                    </div>
                                    <div className="register-form-container-2">
                                        <h3 className='form-head-text'>Organization Details</h3>
                                        <div className="form-group">
                                            <div className="form-field">
                                                <label>Organization Name *</label>
                                                <input type="text" placeholder='Your Organization name' name="companyName" value={formData.companyName} onChange={this.handleChange} validate={[validators.required]} />
                                                {this.state.orgNameMessage && (
                                                    <span className="error-text">{this.state.orgNameMessage}</span>
                                                )}
                                            </div>
                                            <div className="form-field">
                                                <label>Phone Number *</label>
                                                <PhoneInput
                                                    className="phone-input"
                                                    country={'us'}
                                                    value={formData.phoneNumber}
                                                    onChange={this.handlePhoneChange}
                                                    inputProps={{
                                                        name: 'phoneNumber',
                                                        required: true,
                                                        placeholder: 'mobile number'
                                                    }}
                                                />
                                                {this.state.phoneError && (
                                                    <span className="error-text">{this.state.phoneError}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-field">
                                                <label>NPI Number</label>
                                                <input type="text" name="providerNPI" placeholder='NPI is mandatory to view EHR' value={formData.providerNPI} onChange={this.handleChange} />
                                                {this.state.npiError && (
                                                    <span className="error-text">{this.state.npiError}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-field">
                                                <label>Website</label>
                                                <input type="text" name="website" placeholder='https://your-domain.com' value={formData.website} onChange={this.handleChange} />
                                                {this.state.websiteError && (
                                                    <span className="error-text">{this.state.websiteError}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-field">
                                                <label>Address *</label>
                                                <textarea name="providerAddress" placeholder='Enter Address' value={formData.providerAddress} onChange={this.handleChange} />
                                                {this.state.addressError && (
                                                    <span className="error-text">{this.state.addressError}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-field">
                                                <label>Zip Code *</label>
                                                <input name="zipCode" placeholder='Enter ZipCode' value={formData.zipCode} onChange={this.handleChange} maxLength={5} />
                                                {this.state.zipError && (
                                                    <span className="error-text">{this.state.zipError}</span>
                                                )}
                                            </div>
                                            <div className="form-field">
                                                <label>City *</label>
                                                <input name="city" placeholder='Enter City' value={formData.city} onChange={this.handleChange} readOnly={mobileCountry === 'us'} />
                                                {this.state.cityError && (
                                                    <span className="error-text">{this.state.cityError}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-field">
                                                <label>State *</label>
                                                <input name="state" placeholder='Enter State' value={formData.state} onChange={this.handleChange} readOnly={mobileCountry === 'us'} />
                                                {this.state.stateError && (
                                                    <span className="error-text">{this.state.stateError}</span>
                                                )}
                                            </div>
                                            <div className="form-field">
                                                <label>Country *</label>
                                                <input name="country" placeholder='Enter Country' value={formData.country} onChange={this.handleChange} readOnly={mobileCountry === 'us'} />
                                                {this.state.stateError && (
                                                    <span className="error-text">{this.state.stateError}</span>
                                                )}
                                            </div>
                                        </div>
                                        {/* <button
                                        type="button"
                                        className="continue-btn"
                                        onClick={this.handleSubmitForm}
                                    >
                                        {loadingContinue ? <LoadingIcon /> : 'Continue'}
                                    </button> */}
                                        {/* <button type="button" className="submit-btn back-btn" onClick={handlePrevious}>Previous</button> */}
                                        <button
                                            type="btn"
                                            className="continue-btn"
                                            onClick={this.handleSubmitForm}
                                            disabled={loadingContinue}
                                        >
                                            {loadingContinue ? (
                                                <>
                                                    <LoadingIcon />
                                                </>
                                            ) : (
                                                'Continue'
                                            )}
                                        </button>
                                        <p className='previous-btn' onClick={this.handlePrevious}><TfiControlBackward className='pre-icon' /> previous</p>
                                        <p className='login-quotes'>Already have an account? <span onClick={this.handleSignIn}>SignIn</span></p>
                                    </div>
                                </div>
                            )}
                            {formStep === 3 && (
                                <AgreementSteps onAgreementComplete={this.handleAgreementComplete} />
                            )}
                        </form>
                    </div>
                    <div className='right-container'>
                        <div className="image-side">
                            <img src="/static/images/logo-white.png" alt="Healthcare" className="spin-image" />
                        </div>
                        <div className='register-quotes'>
                            <h2 className="typing-animatio">Welcome to Calcium!</h2>
                            <h4>Your Health Journey starts here — with care, compassion, and connection.</h4>
                            <h6>
                                Thank you for choosing a smarter way to manage Patients. <br />
                                Unified access to health records. Safe and secure health data with a HIPAA-compliant platform.
                            </h6>
                        </div>
                    </div>
                </div>
                <div>
                    <Footer></Footer>
                </div>
            </div>
        );
    }
}


PdlRegister.displayName = 'PdlRegister';
PdlRegister.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    // registering: PropTypes.bool.isRequired,
    authConnection: PropTypes.object.isRequired,
    errorMessage: PropTypes.string
};
function mapStateToProps(state) {
    return {
        authConnection: authConnection(state),
        unverifiedEmail: state.identity.unverifiedEmail,
        identity: state.identity
    };
}
function mapDispatchToProps(dispatch) {
    const actions = { getAuthConnection, signIn, resetConnection, loading, onboardOrg, onBoard, checkEmailExists };
    return { actions: bindActionCreators(actions, dispatch) };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'signin-register-reset',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(PdlRegister)));
